import { Suspense, forwardRef } from 'react'
import { useTranslation } from 'react-i18next'

import { DEFAULT_HEIGHT } from './constants'
import LazyRichTextEditor from './RichTextEditor/LazyRichTextEditor'
import type { RichTextEditorHandle, RichTextEditorProps } from './RichTextEditor/types'
import { EditorShell } from './styled-components'

export type { RichTextEditorHandle as HOPRichTextEditorHandle, RichTextEditorProps as HOPRichTextEditorProps }

const HOPRichTextEditor = forwardRef<RichTextEditorHandle, RichTextEditorProps>(
  ({ height = DEFAULT_HEIGHT, ...props }, ref) => {
    const { t } = useTranslation()

    return (
      <Suspense
        fallback={
          <EditorShell $height={height} aria-busy='true'>
            {t('common:loading')}
          </EditorShell>
        }
      >
        <LazyRichTextEditor ref={ref} height={height} {...props} />
      </Suspense>
    )
  },
)

HOPRichTextEditor.displayName = 'HOPRichTextEditor'

export default HOPRichTextEditor
